import React from "react";
import "./WelcomeSection.css";
import { Link } from "react-router-dom";

import FloatingLines from './FloatingLines';

const WelcomeSection = () => {
  return (
    <section className="welcome">
      <div className="welcome-background">
        <FloatingLines
           enabledWaves={['top', 'middle', 'bottom']}
           lineCount={[7, 7, 7]}
           lineDistance={[4, 5, 6]}
           topWavePosition={{ x: 10.0, y: 0.5, rotate: -0.4 }}
           middleWavePosition={{ x: 5.0,  y: 0.0, rotate: 0.2 }}
           bottomWavePosition={{ x: 2.0, y: -0.7, rotate: -1 }}
           interactive={true}
           parallax={true}
           mixBlendMode="screen"
        />
      </div>

      <div className="welcome-content structured-layout">
        {/* Columna izquierda */}
        <div className="left-column">
          <a href="/" className="welcome-logo">
            <img src="/img/logotipo-02.png" alt="Logo SparklingTech" />
          </a>

          <h1 className="welcome-title">
            Tecnología y ciencia para transformar la calidad de vida
          </h1>

          <p className="subtitle-text">
           Desarrollamos soluciones basadas en neurociencia, inteligencia artificial y videojuegos desde nuestro laboratorio de I + D + i
          </p>

          <Link
            to="/movespark"
            className="lit-up-button"
            data-aos="zoom-in"
            data-aos-delay="600"
            data-aos-duration="800"
            data-aos-easing="ease-in-out"
            data-aos-once="true"
          >
            <div className="lit-up-border" />
            <div className="lit-up-content">
              Nuestro laboratorio
            </div>
          </Link>

        </div>

        {/* Columna derecha: logos en horizontal con línea divisoria */}
        <div className="right-column">
{/* Logo ADAIA reemplazando a MoveSpark */}
          <Link
            to="https://adaia.sparklingtech.es/"
            className="project-logo adaia"
            data-aos="flip-left"
            data-aos-delay="300"
            data-aos-duration="1000"
            data-aos-easing="ease-in-out"
            data-aos-once="true"
            style={{ width: '170px', height: '170px'}}
          >
            <img src="/img/ADAIA_logo_1.png" alt="ADAIA"/>
            <p className="project-title" style={{ color: 'white', fontSize: '1.5rem', textAlign: 'center', marginTop: '-30px', justifyContent: 'center', alignItems: 'center', display: 'flex', width: '100%', height: '100%', fontWeight: 'bold', fontFamily: 'Inter, sans-serif' }}>ADAIA</p>
          </Link>

          {/*<div className="divider-home"></div>*/}
          <div style={{ width: '20px', height: '10px' }}></div>

          <Link
      to="https://neuroglint.sparklingtech.es/"
      className="project-logo"
      data-aos="flip-left"
      data-aos-delay="300"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
      data-aos-once="true"
      aria-label="Ir a NeuroGlint"
      style={{ width: '170px', height: '170px' }}
    >
      <img src="/img/NeuroglintBlanco_corto.png" alt="NeuroGlint"/>
      <p className="project-title" style={{ color: 'white', fontSize: '1.5rem', textAlign: 'center', marginTop: '-30px', justifyContent: 'center', alignItems: 'center', display: 'flex', width: '100%', height: '100%', fontWeight: 'bold', fontFamily: 'Inter, sans-serif' }}>NeuroGlint</p>
    </Link>
    
        </div>
      </div>
    </section>
  );
};

export default WelcomeSection;
